<template>
	<div>
		<v-btn fixed dark fab bottom right color="secondary" @click="dialog = true">
			<v-icon>mdi-message-draw</v-icon>
		</v-btn>
		<v-dialog v-model="dialog" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Обратная связь</span>
				</v-card-title>

				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field v-model="model.name" label="Имя"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="model.email" label="Email*" required></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-select
									:items="items"
									v-model="model.type"
									label="Тип обращения"
									item-text="text"
									item-value="value"
									required
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-textarea
									v-model="model.message"
									label="Сообщение*"
									required
								></v-textarea>
							</v-col>
							<v-col cols="12">
								<v-file-input
									label="Загрузить картинку"
									show-size
									v-model="model.file"
									:rules="rules"
									accept="image/*"
									filled
									prepend-icon="mdi-camera"
								></v-file-input>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialog = false">Отмена</v-btn>
					<v-btn color="blue darken-1" text @click="onSubmit">Отправить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :color="snackcolor" :timeout="6000">
			{{ snacbarText }}
		</v-snackbar>
	</div>
</template>

<script>
	export default {
		name: 'Dialog',

		data: function () {
			return {
				dialog: false,
				snackbar: false,
				snackcolor: 'error',
				snacbarText: '',
				items: [
					{ text: 'Вопрос', value: 0 },
					{ text: 'Предложение', value: 1 },
					{ text: 'Ошибка', value: 2 },
				],
				model: {
					type: { text: 'Вопрос', value: 0 },
					file: null,
					message: '',
					name: '',
					email: ''
				},
				rules: [
					value => !value || value.size < 2000000 || 'Размер картинки не должен привышать 2 MB!',
				]
			}
		},

		methods: {
			onSubmit () {
				let formData = new FormData();
				for (let key in this.model) {
					formData.append(key, key === 'type' ? this.items[this.model[key].value].text : this.model[key]);
				}

				this.$api.post(this.$api.urls.feedbacks, formData).then(() => {
					this.dialog = false;
					this.snacbarText = "Спасибо за ваш отзыв!";
					this.snackcolor = "success";
					this.snackbar = true;
					this.model = {
						type: { text: 'Вопрос', value: 0 },
						file: null,
						message: '',
						name: '',
						email: ''
					};
				}, (err) => {
					this.snacbarText = err.data.notyMessage;
					this.snackcolor = "error";
					this.snackbar = true;
				})
			}
		},
	}
</script>
